import React from "react";
import { connect } from "react-redux";
//import $ from 'jquery'
import { store } from "../_helpers";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import axios from "axios";
import { adminuserActions } from "../_actions";
import "react-tabs/style/react-tabs.css";
import {
  Badge,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card,
  CardImg,
  ButtonToolbar,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormCheckbox,
  Container,
  FormTextarea,
  CardHeader,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  ButtonGroup
} from "shards-react";
import { CrearABMFormulario, ConsABMFormulario, PermABMFormulario } from ".";
import PageTitle from "../_components/PageTitle";
import { API_URL } from "../_config";
import openNotificationWithIcon from "../_common/OpenNotificationWithIcon";

class EditarABMFormulario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      nav_number: 0,
      cons: true,
      perm: true,
      id_user: 0,
      user_data: {},
      permisos_usados: {},
      dealers_usados: {},
      loadingx: true,
      };

    //const items = this.props.vehicles;
    //console.log('aca ?', items);
    this.toggle = this.toggle.bind(this);
    this.update_user = this.update_user.bind(this);
    this.assign_cons = this.assign_cons.bind(this);
    this.assign_perms = this.assign_perms.bind(this);
    this.getDataFormSelect = this.getDataFormSelect.bind(this);
  }

  componentWillMount() {
    this.getDataFormSelect()
  }
  async getDataFormSelect(){
    await axios({
      method: "get",
      url:
        API_URL + "api/services/"+ this.props.id_user +"?token=" +
        store.getState().authentication.user.token
    }).then(response => {
      this.setState({
        id_user: response.data.id,
        user_data: response.data,
        loadingx:false
      });
    });
  }
  update_user(values) {
    axios.post(API_URL + 'api/services/'+ this.props.id_user +'?token=' +
    store.getState().authentication.user.token, {
      elementos: values.elementos,
      id: this.props.id_user,
      importe: values.importe,
      categoria: values.categoria,
    }).then(response => {
      this.setState({open : false})
      this.props.getFormularios()
      openNotificationWithIcon('success', 'Listo!','Formulario Actualizado correctamente!')
    }).catch(error => {
      this.setState({open : false})
      this.props.getFormularios(false)
      openNotificationWithIcon('error', 'Ooops! hemos tenido un error al actualizar!',`${error.response || error}`)
    })
  }
  assign_cons(values) {

    axios.post(API_URL + 'api/user/'+ this.state.id_user +'/dealers?token=' +
    store.getState().authentication.user.token, values).then(response => {
      console.log(response);
    });


  } 

  assign_perms(values) {

    axios.post(API_URL + 'api/user/'+ this.state.id_user +'/perms?token=' +
    store.getState().authentication.user.token, values).then(response => {
      console.log(response);
    });


  } 

  toggle() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { open } = this.state;

  


    if(open == false) {
      return (<></>);
    }else{
    return (
      <div>
      
          <Modal open={open} toggle={() => console.log('Toggle')}>
            <ModalHeader>Editar  <i style={{position:'absolute', right: '20px', top: '15px', fontSize: '25px', cursor: 'pointer'}} class="material-icons" onClick={this.toggle}>clear</i></ModalHeader>
            <ModalBody>
              <Nav tabs>
                <NavItem active={this.state.nav_number == 0 ? true : false}>
                  <NavLink
                    onClick={() => {
                      this.setState({
                        nav_number: 0
                      });
                    }}
                    href="#"
                  >
                    Datos
                  </NavLink>
                </NavItem>
                
              </Nav>
              <br />
              <br />
              
              
                <CrearABMFormulario activedX={this.state.user_data} edit={true} onSubmit={this.update_user} />
           
              
              
              </ModalBody>
          </Modal>
          </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    );
              }
  }
}

function mapState(state, props) {
  const { users, authentication, vehicles, adminuser } = state;

  const { user } = authentication;
  console.log("esto ->", vehicles);

  return { user, users, adminuser };
}

const actionCreators = {
 
};

const connectedABMFormularios = connect(
  mapState,
  actionCreators
)(EditarABMFormulario);
export { connectedABMFormularios as EditarABMFormulario };
  